// export this package's api
import Loadable from "../../react-loadable";
// import TreeSelect from './Select';
import TreeNode from "./TreeNode";
const TreeSelect = Loadable({
  loader: () => import("./Select.jsx"),
  loading: () => null,
  render: (obj, props, ref) => {
    if (obj) {
      return React.createElement(obj && obj.__esModule ? obj.default : obj, {
        ...props,
        ref
      });
    }
    return null;
  }
});

const SHOW_ALL = "SHOW_ALL";
const SHOW_PARENT = "SHOW_PARENT";
const SHOW_CHILD = "SHOW_CHILD";

TreeSelect.SHOW_ALL = SHOW_ALL;
TreeSelect.SHOW_PARENT = SHOW_PARENT;
TreeSelect.SHOW_CHILD = SHOW_CHILD;

TreeSelect.TreeNode = TreeNode;
export default TreeSelect;



// WEBPACK FOOTER //
// ./_rc-tree-select-1.8.8/src/index.js